<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    max-width="250"
    rounded="lg"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn v-on="on" v-bind="attrs" icon title="Alterar prioridade" :color="carga.prioridade.cor" small
        ><v-icon>mdi-swap-horizontal</v-icon></v-btn
      >
    </template>
    <v-card>
      <v-card-title class="subtitle-2 font-weight-bold"
        >Alterar prioridade</v-card-title
      >
      <v-card-text>
        <v-form ref="form">
          <v-select
            label="Prioridade"
            class="mt-1"
            no-data-text="Nenhuma prioridade encontrada"
            :items="
              configuracoes.dados.prioridades.filter(
                (p) => p.codigo < carga.prioridade.codigo
              )
            "
            v-model="prioridadeSelecionada"
            outlined
            item-text="descricao"
            :rules="[(v) => v > 0 || 'Selecione um prioridade']"
            item-value="codigo"
            :disabled="alterando"
          >
            <template v-slot:item="{ item }">
              <chip-prioridade-form-carga small :prioridade="item" />
            </template>
            <template v-slot:selection="{ item }">
              <chip-prioridade-form-carga small :prioridade="item" />
            </template>
          </v-select>
        </v-form>
        <v-row>
          <v-col cols="6">
            <v-btn
              text
              color="success"
              block
              class="font-weight-bold"
              rounded
              @click="confirmar()"
              :loading="alterando"
              >Confirmar</v-btn
            >
          </v-col>
          <v-col cols="6">
            <v-btn
              class="font-weight-bold"
              text
              rounded
              @click="menu = false"
              :disabled="alterando"
              >Cancelar</v-btn
            >
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-menu>
</template>

<script>
import axios from "axios";
import { mapActions, mapState } from "vuex";
import ChipPrioridadeFormCarga from "./ChipPrioridadeFormCarga.vue";
export default {
  watch: {
    menu: function (open) {
      if (open) this.prioridadeSelecionada = 0;
    },
  },
  components: { ChipPrioridadeFormCarga },
  props: {
    carga: { type: Object, required: true },
  },
  computed: mapState("formacaoCarga", ["configuracoes","cargas"]),
  data: () => ({
    menu: false,
    prioridadeSelecionada: 0,
    alterando: false,
  }),
  methods: {
    ...mapActions("formacaoCarga",["buscarCargas"]),
    async confirmar() {
      if (this.$refs.form.validate()) {
        this.alterando = true;
        await axios
          .post(
            "/nutricao-animal/formacao-carga/alterar-prioridade",
            JSON.stringify({
              id_carga: this.carga.id,
              cod_prioridade: this.prioridadeSelecionada,
            })
          )
          .then(async (res) => {
            if (res.data.success) {
              this.$toasted.success(res.data.msg);
              this.menu = false
              await this.buscarCargas()
            } else {
              this.$toasted.error(res.data.msg);
            }
          })
          .catch((e) => this.$toasted.error(e))
          .finally(() => {
            this.alterando = false;
          });
      }
    },
  },
};
</script>

<style>
</style>